/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
					path => router path
					name => router name
					component(lazy loading) => component to load
					meta : {
					  rule => which user can have access (ACL)
					  breadcrumb => Add breadcrumb to specific page
					  pageTitle => Display title besides breadcrumb
					}
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import Config from '../config'
Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: Config.baseURL,
	scrollBehavior() {
		return { x: 0, y: 0 }
	},
	routes: [
		// {
		// 	path: '/ver2',
		// 	// component: () => import('./layouts/PrepareLayout/index.vue'),
		// 	meta: {
		// 	},
		// 	children: [
		// 		{
		// 			path: '/',
		// 			name: 'page1',
		// 			component: () => import('./pages/ver2/Page1.vue'),
		// 			meta: {
		// 			}
		// 		},
		// 		{
		// 			path: 'page2',
		// 			name: 'page2',
		// 			component: () => import('./pages/ver2/Page2.vue'),
		// 			meta: {
		// 			}
		// 		},
		// 		{
		// 			path: 'page3',
		// 			name: 'page3',
		// 			component: () => import('./pages/ver2/Page3.vue'),
		// 			meta: {
		// 			}
		// 		},
		// 		{
		// 			path: 'page4',
		// 			name: 'page4',
		// 			component: () => import('./pages/ver2/Page4.vue'),
		// 			meta: {
		// 			}
		// 		},
		// 		{
		// 			path: 'page5',
		// 			name: 'page5',
		// 			component: () => import('./pages/ver2/Page5.vue'),
		// 			meta: {
		// 			}
		// 		},
		// 		{
		// 			path: 'page6',
		// 			name: 'page6',
		// 			component: () => import('./pages/ver2/Page6.vue'),
		// 			meta: {
		// 			}
		// 		},
		// 		{
		// 			path: 'page7',
		// 			name: 'page7',
		// 			component: () => import('./pages/ver2/Page7.vue'),
		// 			meta: {
		// 			}
		// 		},
		// 		{
		// 			path: 'page8',
		// 			name: 'page8',
		// 			component: () => import('./pages/ver2/Page8.vue'),
		// 			meta: {
		// 			}
		// 		}
				
		// 	]
		// },
		{
			path: '/auth',
			component: () => import('./pages/Auth.vue'),
		},
		{
			path: '/',
			component: () => import('./themes/index.vue'),
			children: [
				{
					path: '/:slug',
					name: 'index',
					// component: () => import('./pages/Index.vue'),
					meta: {
					}
				},
				{
					path: '/:slug/:examSlug',
					name: 'index_with_exam',
					// component: () => import('./pages/Index.vue'),
					meta: {
					}
				},
			]
		},
		{
			path: '*',
			redirect: '/pages/error-404'
		}
	]
})

router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById('loading-bg')
	if (appLoading) {
		appLoading.style.display = 'none'
	}
})

router.beforeEach((to, from, next) => {

	//   if (to.meta.authRequired) {
	//     if (!(auth.isAuthenticated())) {
	//       router.push({ path: '/pages/login', query: { to: to.path } })
	//     }
	//   }

	//   if (to.path === '/pages/login' && auth.isAuthenticated()) {
	//     router.push({ path: '/' })
	//   }

	return next()

})

export default router
